/* eslint-disable @typescript-eslint/naming-convention */
import { type App, reactive } from 'vue';

import { OrderTypeName } from '@/components/account/order-card/types';
import { ValueOf } from '@/utils/types/value-of';

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $order: TOrder;
  }
}

const orderData = reactive({
  currentOrderNumber: '',
  orderType: '' as ValueOf<typeof OrderTypeName>,
  isShown: false,
});

const $order = {
  data: orderData,

  show(currentOrderNumber: string, orderType: ValueOf<typeof OrderTypeName>) {
    orderData.orderType = orderType;
    orderData.currentOrderNumber = currentOrderNumber;
    orderData.isShown = true;
  },

  hide() {
    orderData.isShown = false;
  },
} as const;

type TOrder = typeof $order;

// TODO: вынести это в стейт или composable
export default {
  install: (app: App) => {
    // eslint-disable-next-line no-param-reassign
    app.config.globalProperties.$order = $order;
  },
};
